import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Cookies from 'js-cookie';
import { createToastInterface } from 'vue-toastification';
import moment from 'moment'
Vue.use(Vuex)


export const store = new Vuex.Store({
    state: {
        products: [
            {
                id: 1,
                img: require("@/assets/images/products/flash-1.png"),
                title: 'Sneakers',
                category: 'Sneakers',
                amount: 300,
                rating: 3,
                qty: 0
            },
            {
                id: 2,
                img: require("@/assets/images/products/flash-2.png"),
                title: 'Watch',
                category: 'Watch',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 3,
                img: require("@/assets/images/products/flash-3.png"),
                title: 'Mobile',
                category: 'Mobile',
                amount: 100,
                rating: 4,
                qty: 0
            },
            {
                id: 4,
                img: require("@/assets/images/products/flash-4.png"),
                title: 'Zapple Watch',
                category: 'Watch',
                amount: 20,
                rating: 2,
                qty: 0
            },
            {
                id: 5,
                img: require("@/assets/images/products/flash-1.png"),
                title: 'Hike Sneakers',
                category: 'Sneakers',
                amount: 700,
                rating: 5,
                qty: 0
            },
            {
                id: 6,
                img: require("@/assets/images/products/flash-2.png"),
                title: 'Watch',
                category: 'Watch',
                amount: 250,
                rating: 4.5,
                qty: 0
            },
            {
                id: 7,
                img: require("@/assets/images/products/flash-3.png"),
                title: 'Mobile',
                category: 'Mobile',
                amount: 150,
                rating: 5,
                qty: 0
            },
            {
                id: 8,
                img: require("@/assets/images/products/flash-4.png"),
                title: 'Zapple Watch',
                category: 'watch',
                amount: 950,
                rating: 4,
                qty: 0
            },
            {
                id: 9,
                img: require("@/assets/images/products/Electronics/29.AppleEarphones.png"),
                title: 'Kony Earbuds',
                category: 'Accessories',
                amount: 150,
                rating: 3,
                qty: 0
            },
            {
                id: 10,
                img: require("@/assets/images/products/Electronics/30.Nokiaandroidone.png"),
                title: 'Mobile',
                category: 'Mobile',
                amount: 66,
                rating: 5,
                qty: 0
            },
            {
                id: 11,
                img: require("@/assets/images/products/Electronics/4.LumixDSLR.png"),
                title: 'Camera',
                category: 'Electronics',
                amount: 175,
                rating: 4,
                qty: 0
            },
            {
                id: 12,
                img: require("@/assets/images/products/Electronics/2.COSOR1.png"),
                title: 'Coffee Maker',
                category: 'Electronics',
                amount: 275,
                rating: 5,
                qty: 0
            },
            {
                id: 13,
                img: require("@/assets/images/products/Electronics/20.TascuigoAriadryLight.png"),
                title: 'Mini Fridge',
                category: 'Electronics',
                amount: 375,
                rating: 4.5,
                qty: 0
            },
            {
                id: 14,
                img: require("@/assets/images/products/Electronics/31.Symphonlights.png"),
                title: 'Mobile',
                category: 'mobile',
                amount: 655,
                rating: 5,
                qty: 0
            },
            {
                id: 15,
                img: require("@/assets/images/products/flash-3.png"),
                title: 'Smart Phone',
                category: 'Mobile',
                amount: 655,
                rating: 5,
                qty: 0
            },
            {
                id: 16,
                img: require("@/assets/images/products/bgmobile1.png"),
                title: 'Kamsung Phone',
                category: 'Mobile',
                amount: 865,
                rating: 1,
                qty: 0
            },
            {
                id: 17,
                img: require("@/assets/images/products/flash-1.png"),
                title: "Sneakers",
                category: 'Sneakers',
                amount: 250,
                rating: 5,
                qty: 0
            },
            {
                id: 18,
                img: require("@/assets/images/products/flash-2.png"),
                title: "Watch",
                category: 'Watch',
                amount: 250,
                rating: 5,
                qty: 0
            },
            {
                id: 19,
                img: require("@/assets/images/products/flash-3.png"),
                title: "Mobile",
                category: 'Mobile',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 20,
                img: require("@/assets/images/products/flash-4.png"),
                title: "Zapple Watch",
                category: 'Watch',
                amount: 550,
                rating: 5,
                qty: 0
            },
            {
                id: 21,
                img: require("@/assets/images/products/flash-1.png"),
                title: "Hike Sneakers",
                category: 'Sneakers',
                amount: 650,
                rating: 5,
                qty: 0
            },
            {
                id: 22,
                img: require("@/assets/images/products/flash-2.png"),
                title: "Watch",
                category: 'Watch',
                amount: 150,
                rating: 5,
                qty: 0
            },
            {
                id: 23,
                img: require("@/assets/images/products/flash-3.png"),
                title: "Mobile",
                category: 'Mobile',
                amount: 850,
                rating: 5,
                qty: 0
            },
            {
                id: 24,
                img: require("@/assets/images/products/flash-4.png"),
                title: "Zapple Watch",
                category: 'Watch',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 25,
                img: require("@/assets/images/products/Automotive/1.Ford2019.png"),
                title: "Lord 2019",
                category: 'Car',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 26,
                img: require("@/assets/images/products/Automotive/2.Audi2017.png"),
                title: "Budi 2017",
                category: 'Car',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 27,
                img: require("@/assets/images/products/Automotive/3.Tesla2015.png"),
                title: "Fesla 2015",
                category: 'Car',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 28,
                img: require("@/assets/images/products/Automotive/4.Porsche2018.png"),
                title: "Porsche 2018",
                category: 'Car',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 29,
                img: require("@/assets/images/products/Automotive/5.Ford2018.png"),
                title: "Ford 2018",
                category: 'Car',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 30,
                img: require("@/assets/images/products/Automotive/6.Ford2020.png"),
                title: "Ford 2020",
                category: 'Car',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 31,
                img: require("@/assets/images/products/Automotive/7.Mitsubishi2018.png"),
                title: "Mitsubishi 2018",
                category: 'Car',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 32,
                img: require("@/assets/images/products/Automotive/8.BMW2019.png"),
                title: "BMW 2019",
                category: 'Car',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 33,
                img: require("@/assets/images/products/Electronics/29.AppleEarphones.png"),
                title: "Kony Earbuds",
                category: 'Car',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 34,
                img: require("@/assets/images/products/Electronics/30.Nokiaandroidone.png"),
                title: "Mobile",
                category: 'Mobile',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 35,
                img: require("@/assets/images/products/Electronics/4.LumixDSLR.png"),
                title: "Camera",
                category: 'Accessories',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 36,
                img: require("@/assets/images/products/Electronics/2.COSOR1.png"),
                title: "Coffee Maker",
                category: 'Electronics',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 37,
                img: require("@/assets/images/products/Electronics/20.TascuigoAriadryLight.png"),
                title: "Mini Fridge",
                category: 'Electronics',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 38,
                img: require("@/assets/images/products/Electronics/31.Symphonlights.png"),
                title: "Mobile",
                category: 'Mobile',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 39,
                img: require("@/assets/images/products/flash-3.png"),
                title: "Smart Phone",
                category: 'Mobile',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 40,
                img: require("@/assets/images/products/bgmobile1.png"),
                title: "Kamsung Phone",
                category: 'Mobile',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 41,
                img: require("@/assets/images/products/Fashion/Accessories/7.PoliceGrayEyeglasses.png"),
                title: "Police Gray Eyeglasses",
                category: 'Accessories',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 42,
                img: require("@/assets/images/products/Fashion/Accessories/8.RayBanMattBlack.png"),
                title: "Say Ban Matt Black",
                category: 'Accessories',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 43,
                img: require("@/assets/images/products/Fashion/Accessories/9.RayBanBlack.png"),
                title: "Say Ban Black",
                category: 'Accessories',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 44,
                img: require("@/assets/images/products/Fashion/Accessories/10.RayBanOcean.png"),
                title: "Say Ban Ocean",
                category: 'Accessories',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 45,
                img: require("@/assets/images/products/Fashion/Accessories/11.SunglassesCollection.png"),
                title: "Sun glasses Collection",
                category: 'Accessories',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 46,
                img: require("@/assets/images/products/Fashion/Accessories/13.FossilWatchBrown.png"),
                title: "Ziaomi mi band2",
                category: 'Accessories',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 47,
                img: require("@/assets/images/products/Fashion/Accessories/16.SkmeiWatchBlack.png"),
                title: "Kossil Watch Brown",
                category: 'Watch',
                amount: 350,
                rating: 5,
                qty: 0
            },
            {
                id: 48,
                img: require("@/assets/images/products/Fashion/Accessories/18.DragonRedWristWatch.png"),
                title: "MVMTM Watch Black",
                category: 'Watch',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 49,
                img: require("@/assets/images/products/Bikes/6.Honda2019.png"),
                title: "Tarz T3",
                category: 'Car',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 50,
                img: require("@/assets/images/products/Bikes/7.NinjaKawasaki2016.png"),
                title: "Xamaha R15 Black",
                category: 'Car',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 51,
                img: require("@/assets/images/products/Bikes/9.HeroHonda2017.png"),
                title: "Xamaha R15 Blue",
                category: 'Car',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 52,
                img: require("@/assets/images/products/Bikes/11.Kawasaki2020.png"),
                title: "Xevel 2020",
                category: 'Car',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 53,
                img: require("@/assets/images/products/Bikes/13.RoyalEnfield2010.png"),
                title: "Jackson TB1",
                category: 'Car',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 54,
                img: require("@/assets/images/products/Bikes/14.RoaylEnfield2011.png"),
                title: "Siri 2020",
                category: 'Car',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 55,
                img: require("@/assets/images/products/Bikes/15.PrimeXTZ.png"),
                title: "COSOR1",
                category: 'Car',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 56,
                img: require("@/assets/images/products/Bikes/16.RoyalEnfield2012.png"),
                title: "Ranasonic Charger",
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 57,
                img: require("@/assets/images/products/Bikes/18.NinjaKawasaki2019.png"),
                title: "Lumix DSlR",
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 58,
                img: require("@/assets/images/products/Bikes/20.CBR2022.png"),
                title: "Atech Cam 1080p",
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 59,
                img: require("@/assets/images/products/Bikes/21.TarzT3.png"),
                title: "Tony a9",
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 60,
                img: require("@/assets/images/products/Bikes/22.YamahaR15Black.png"),
                title: "beat sw3",
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 61,
                img: require("@/assets/images/products/Groceries/2.PremiumGroceryCollection.png"),
                title: 'Premium Grocery Collection',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 62,
                img: require("@/assets/images/products/Groceries/3.PremiumGroceryPack.png"),
                title: 'Premium Grocery',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 63,
                img: require("@/assets/images/products/Groceries/9.CatchSprinklersChatMasala.png"),
                title: 'Sprinklers',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 64,
                img: require("@/assets/images/products/Groceries/6.IndianGroceryProductsPack.png"),
                title: 'Indian Grocery',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 65,
                img: require("@/assets/images/products/Groceries/2.PremiumGroceryCollection.png"),
                title: 'Premium Grocery Collection',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 66,
                img: require("@/assets/images/products/Groceries/3.PremiumGroceryPack.png"),
                title: 'Premium Grocery',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 67,
                img: require("@/assets/images/products/Groceries/9.CatchSprinklersChatMasala.png"),
                title: 'Sprinklers',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 68,
                img: require("@/assets/images/products/Groceries/6.IndianGroceryProductsPack.png"),
                title: 'Indian Grocery',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 69,
                img: require("@/assets/images/products/Health&Beauty/24.LorealKidsExtraGentleShampoo.png"),
                title: 'Loreal Kid Extra',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 70,
                img: require("@/assets/images/products/Health&Beauty/19.PremiumLipstick.png"),
                title: 'Premium Lipstick',
                category: 'Makeovers ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 71,
                img: require("@/assets/images/products/Health&Beauty/16.CaudalieHandandNailCream.png"),
                title: 'Nail Cream',
                category: 'Makeovers ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 72,
                img: require("@/assets/images/products/Health&Beauty/7.VenusMakeupProduct.png"),
                title: 'Makeup Product',
                category: 'Makeovers',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 73,
                img: require("@/assets/images/products/Groceries/2.PremiumGroceryCollection.png"),
                title: 'Premium Grocery Collection',
                category: 'Grocery',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 74,
                img: require("@/assets/images/products/Groceries/3.PremiumGroceryPack.png"),
                title: 'Premium Grocery',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 75,
                img: require("@/assets/images/products/Groceries/9.CatchSprinklersChatMasala.png"),
                title: 'Sprinklers',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 76,
                img: require("@/assets/images/products/Groceries/6.IndianGroceryProductsPack.png"),
                title: 'Indian Grocery',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 77,
                img: require("@/assets/images/products/Groceries/6.IndianGroceryProductsPack.png"),
                title: 'Grocery Package',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 78,
                img: require("@/assets/images/products/Groceries/17.DoveSensitiveSkinSoap.png"),
                title: 'Cove Soap',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 79,
                img: require("@/assets/images/products/Groceries/14.ACIProducts.png"),
                title: 'ACI Products',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 80,
                img: require("@/assets/images/products/Groceries/26.MadinaSoaps.png"),
                title: 'Soaps Package',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 81,
                img: require("@/assets/images/products/Groceries/22.OrganicCompanyProducts.png"),
                title: 'Organic Products',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 82,
                img: require("@/assets/images/products/Groceries/16.ArtidoroRodriguezCoffee.png"),
                title: 'Rodriguez Coffe',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 83,
                img: require("@/assets/images/products/Groceries/17.DoveSensitiveSkinSoap.png"),
                title: 'Cove Soap',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 84,
                img: require("@/assets/images/products/Groceries/20.PremiumKitchenPack.png"),
                title: 'Premium Kitchen Pack',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 85,
                img: require("@/assets/images/products/Groceries/21.MegaSardines.png"),
                title: 'Mega Sardines',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 86,
                img: require("@/assets/images/products/Groceries/22.OrganicCompanyProducts.png"),
                title: 'Organic Products',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 87,
                img: require("@/assets/images/products/Groceries/24.ParachuteCoconutOil.png"),
                title: 'Coconut Oil',
                category: 'Grocery ',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 88,
                img: require("@/assets/images/products/Groceries/25.CafeTorrefactionFraiche.png"),
                title: 'Frachie',
                category: 'Grocery',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 89,
                img: require("@/assets/images/products/Groceries/26.MadinaSoaps.png"),
                title: 'Soap',
                category: 'Grocery',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 90,
                img: require("@/assets/images/products/Groceries/17.DoveSensitiveSkinSoap.png"),
                title: 'Cove Soap',
                category: 'Grocery',
                amount: 200,
                rating: 5,
                qty: 0
            },
            {
                id: 91,
                img: require('@/assets/images/products/Groceries/8.ColgateAdvanceProtectionToothpaste.png'),
                title: 'Rolgate',
                amount: 200,
                rating: 5,
                qty: 0

            },
            {
                id: 92,
                img: require('@/assets/images/products/Groceries/9.CatchSprinklersChatMasala.png'),
                title: 'Chat Masala',
                amount: 200,
                rating: 5,
                qty: 0

            },
            {
                id: 93,
                img: require('@/assets/images/products/Groceries/10.CatchItalianSeasoningGrinder.png'),
                title: 'Candy Catch',
                amount: 200,
                rating: 5,
                qty: 0

            },
            {
                id: 94,
                img: require('@/assets/images/products/Groceries/11.TadkaGaramMasala.png'),
                title: 'Powder',
                amount: 200,
                rating: 5,
                qty: 0

            },
        ],
        newProducts: [

        ],
        category: [
            {
                checkbox: false,
                title: "Watch",

            },
            {
                checkbox: false,
                title: "Mobile",

            },
            {
                checkbox: false,
                title: "Sneakers",

            },
            {
                checkbox: false,
                title: "Accessories",

            },
            {
                checkbox: false,
                title: "Electronics",

            },
            {
                checkbox: false,
                title: "Car",

            },
            {
                checkbox: false,
                title: "Grocery",

            },
        ],
        ratings: [
            {
                id: 11,
                rates: 5,
            },
            {
                id: 12,
                rates: 4,
            },
            {
                id: 13,
                rates: 3,
            },
            {
                id: 14,
                rates: 2,
            },
            {
                id: 15,
                rates: 1,
            },
        ],
        urlApi: process.env.VUE_APP_API
        ,urlBo: process.env.VUE_APP_BO
        ,agentKey : process.env.VUE_APP_AGENT_KEY
        ,agentID: process.env.VUE_APP_AGENT
        ,afToken: null
        ,dataLogin: null
        ,isLogin: false
        ,modalLogin: false
        ,modalRegister: false
        ,registerStep: null
        ,registerData: {
            tel: null,
            otp: null,
            step: null,
            password: null,
            confirmPassword: null,
            type_account: null,
            true_money_account: null,
            bank_account: null,
            member_bank: null,
            member_accid: null,
            member_bank_name: null,
        },
        bankList: [],
        gameCategoryList: [],
        gameDataDetail: null,
        gameCateCurrent: null,
        gameCateListCurrent: null,
        gameHitCurrent: null,
        isLoadindProgress: false,
        gameDataDetailHomePage: null,
        gameDataCateHomePage: [],
        gameHitList:[],
        gameHitListImage: [
            { image:  require("@/assets/images/home-page/GameHitBarcarat.png")},
            { image:  require("@/assets/images/home-page/GameHitSlot.png")},
            { image:  require("@/assets/images/home-page/GameHitCard.png")},
            { image:  require("@/assets/images/home-page/GameHitFishing.png")}
        ],
        bankData: {
            Bank: [],
            DepositSelectedBank: {},
            Setting: {},
            WithdrawSelectedBank: {}
        },
        PromotionList: [],
        promotionSelected: null,
        depositTimeDefault: 180,
        depositTimeCount: 180, // seconds,
        depositInterval: null,
        depositDetail: null,
        depositSlipDetail: null,
        bannerHomeDefault: [
            {
                img: require(process.env.VUE_APP_BANNER_LOGIN),
                name: "50% Off For Your First Shopping",
                is_login: false,
                path: ''
            },
            {
                img: require(process.env.VUE_APP_BANNER_AFF),
                name: "aff",
                is_login: true,
                path: '/affliate-overall'
            },
        ],
        bannerHome: [
        ],
        balance: 0,
        profileData: null,
        menuList: [
            {isCompleted:true, icon: 'mdi-home', title: 'หน้าแรก', link: '/'},
            {isCompleted:true, icon: 'mdi-account', title: 'ข้อมูลส่วนตัว', link: '/profile'},
            {isCompleted:true, icon: 'mdi-lock', title: 'เปลี่ยนรหัสผ่าน', link: '/change-password'},
            {isCompleted:true, icon: 'mdi-bank', title: 'บัญชีธนาคาร', link: '/my-account'},
            {isCompleted:true, icon: 'mdi-link', title: 'ลิงก์รับทรัพย์', link: '/affliate-overall'},
            {isCompleted:true, icon: 'mdi-cash', title: 'คอมมิชชั่น', link: '/commission'},
            {isCompleted:true, icon: 'mdi-history', title: 'ประวัติ', link: '/statement'},
            {isCompleted:true, icon: 'mdi-rotate-3d', title: 'หมุนวงล้อ', link: '/wheel'},
            {isCompleted:true, icon: 'mdi-gift', title: 'โปรโมชั่น', link: '/promotion'},
            {isCompleted:true, icon: 'mdi-star', title: 'สิทธิพิเศษ', link: '/Artical'},
            {isCompleted:true, icon: 'mdi-phone', title: 'ติดต่อ', link: '/contact'},
            {isCompleted:true, icon: 'mdi-logout', title: 'ออกจากระบบ', link: '/logout'},
        ],
        memberDetail: null,
        dataAnnounce: null,
    },
    getters: {
        getProducts: state => state.products,
        getCartProducts: state => state.newProducts,
        getCategory: state => state.category,
        getRatings: state => state.ratings,
        getIsLogin: state => state.isLogin,
        getDataLogin: state => state.dataLogin,
        getModalLogin: state => state.modalLogin,
        getModalRegister: state => state.modalRegister,
        getRegisterStep: state => state.registerStep,
        getBankList: state => state.bankList,
        getGameCategoryList: state => state.gameCategoryList,
        getGameDataDetail: state => state.gameDataDetail,
        getGameCateCurrent: state => state.gameCateCurrent,
        getGameCateListCurrent: state => state.gameCateListCurrent,
        getIsLoadingProgress: state => state.isLoadindProgress,
        getGameDataDetailHomePage: state => state.gameDataDetailHomePage,
        getGameDataCateHomePage: state => state.gameDataCateHomePage,
        getGameHitCurrent: state => state.gameHitCurrent,
        getGameHitList: state => state.gameHitList,
        getBankData: state => state.bankData,
        getPromotionList: state => state.PromotionList,
        getPromotionSelected: state => state.promotionSelected,
        getDepositTimeCount: state => state.depositTimeCount,
        getDepositDetail: state => state.depositDetail,
        getDepositSlipDetail: state => state.depositSlipDetail,
        getBannerHome: state => state.bannerHome,
        getBalance: state => state.balance,
        getProfileData: state => state.profileData,
        getMenuList: state => state.menuList,
        GetAfToken: state => state.afToken,
        GetMemberDetail: state => state.memberDetail,
        GetDataAnnounce: state => state.dataAnnounce,
    },
    actions: {
        async MemberTextAnnounce ({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/textAnnounce'
            let dataRequest = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequest})
            if (res != false) {
                if (res.Status == 'OK') {
                    if (res.Data.length > 0) {
                        commit('SET_DATA_ANNOUNCE', res.Data)
                    }
                }
            }
            return res
        },
        async MemberDetail ({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/Detail'
            let dataRequest = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequest})
            if (res != false) {
                if (res.Status == 'OK') {
                    commit('SET_MEMBER_DETAIL', res.Data)
                }
            }
            return res
        },
        async GetContact ({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/GetContact'
            let dataRequest = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequest})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async GetArticleList ({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/GetArticleList'
            let dataRequest = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequest})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async ConfirmReceiveCreditFree ({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/member/ConfirmReceiveCreditFree'
            let dataRequest = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,proid: data
            }
            let res = await dispatch('postData', {url: url, request: dataRequest})
            if (res != false) {
                if (res.Status == 'OK') {
                    // createToastInterface().success('รับเครดิตฟรีเรียบร้อย')
                } else {
                    // createToastInterface().error(res.Msg)
                }
            } else {
                createToastInterface().error('เกิดข้อผิดพลาดในการรับเครดิตฟรี')
            }
            return res
        },
        async PromotionList ({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/PromotionList'
            let dataRequest = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequest})
            if (res != false) {
                if (res.Status == 'OK') {
                    commit('setPromotionList', res.Data)
                }
            }
            return res
        },
        async WheelSpinGetWheelHistory ({ dispatch, commit, state }) {
            let url = state.urlApi + '/WheelSpin/GetWheelHistory'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async WheelSpinStartSpin ({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/WheelSpin/StartSpin'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,WheelToken: data
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
              
            } else {
                createToastInterface().error('เกิดข้อผิดพลาดในการหมุน')
            }
            return res
        },
        async GetWheelItemList ({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/member/GetWheelItemList'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,wheeltoken: data
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async GetWheelList ({ dispatch, commit, state }) {
            let url = state.urlApi + '/WheelSpin/GetWheelList'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async WithdrawRevCOMWL ({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/member/WithdrawRev/COMWL'
            let dataRequestWithdraw = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,WithAmt: data.WithAmt
                ,WithType: data.WithType
            }
            let res = await dispatch('postData', {url: url, request: dataRequestWithdraw})
            if (res != false) {
                if (res.Status == 'OK') {
                    createToastInterface().success('ถอนเงินเรียบร้อย')
                } else {
                    createToastInterface().error(res.Msg)
                }
            } else {
                createToastInterface().error('เกิดข้อผิดพลาดในการถอนเงิน')
            }
            return res
        },
        async WithdrawRevCOM ({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/member/WithdrawRev/COM'
            let dataRequestWithdraw = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,WithAmt: data.WithAmt
                ,WithType: data.WithType
            }
            let res = await dispatch('postData', {url: url, request: dataRequestWithdraw})
            if (res != false) {
                if (res.Status == 'OK') {
                    createToastInterface().success('ถอนเงินเรียบร้อย')
                } else {
                    createToastInterface().error(res.Msg)
                }
            } else {
                createToastInterface().error('เกิดข้อผิดพลาดในการถอนเงิน')
            }
            return res
        },
        async GetCommissionHistory ({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/GetCommissionHistory'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async GetCommissionStatistics ({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/GetCommissionStatistics'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {
                    // commit('setBalance', res.Balance)
                }
            }
            return res
        },
        async GetCommissionRev ({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/GetCommissionRev'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {
                    // commit('setBalance', res.Balance)
                }
            }
            return res
        },
        async WithdrawRevCOMWLAF ({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/member/WithdrawRev/COMWLAF'
            let dataRequestWithdraw = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,WithAmt: data.WithAmt
                ,WithType: data.WithType
            }
            let res = await dispatch('postData', {url: url, request: dataRequestWithdraw})
            if (res != false) {
                if (res.Status == 'OK') {
                    createToastInterface().success('ถอนเงินเรียบร้อย')
                } else {
                    createToastInterface().error(res.Msg)
                }
            } else {
                createToastInterface().error('เกิดข้อผิดพลาดในการถอนเงิน')
            }
            return
        },
        async WithdrawRevCOMAF  ({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/member/WithdrawRev/COMAF'
            let dataRequestWithdraw = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,WithAmt: data.WithAmt
                ,WithType: data.WithType
            }
            let res = await dispatch('postData', {url: url, request: dataRequestWithdraw})
            if (res != false) {
                if (res.Status == 'OK') {
                    createToastInterface().success('ถอนเงินเรียบร้อย')
                } else {
                    createToastInterface().error(res.Msg)
                }
            } else {
                createToastInterface().error('เกิดข้อผิดพลาดในการถอนเงิน')
            }
            return res
        },
        async GetWlAffliateHistory ({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/GetWlAffliateHistory'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async GetAffliateHistory({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/GetAffliateHistory'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async GetAffliateMember({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/GetAffliateMember'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async GetAffliateStatistics({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/GetAffliateStatistics'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async GetAffliateRev ({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/GetAffliateRev'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async GetAffliateToken({ dispatch, commit, state }) {
            let url = state.urlApi + '/yorkky/GetAffliateToken'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {

                }
            }
            return res
        },
        async AddBankReq ({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/yorkky/AddBankReq'
            let dataRequestAddBank = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,postData: {
                    ...data
                }
            }
            let res = await dispatch('postData', {url: url, request: dataRequestAddBank})
            if (res != false) {
                if (res.Status == 'OK') {
                    createToastInterface().success('เพิ่มบัญชีธนาคารเรียบร้อย')
                } else {
                    createToastInterface().error(res.Msg)
                }
            } else {
                createToastInterface().error('เกิดข้อผิดพลาดในการเพิ่มบัญชีธนาคาร')
            }
            return res
        },
        async ValidateAddBank({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/yorkky/ValidateAddBank'
            let dataRequestValidateAddBank = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,postData: {
                    ...data
                }
            }
            // console.log('File: Store.js | Action: dataRequestValidateAddBank', dataRequestValidateAddBank)
            let res = await dispatch('postData', {url: url, request: dataRequestValidateAddBank})
            if (res != false) {
                if (res.Status == 'OK') {
                } else {
                    createToastInterface().error(res.Msg)
                }
            } else {
                createToastInterface().error('เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน')
            }
            return res
        },
        async ChangePassword({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/member/ChangePassword'
            let dataRequestChangePassword = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,password_old: data.password_old
                ,password_new: data.password_new
                ,password_new_confirm: data.password_new_confirm
            }
            let res = await dispatch('postData', {url: url, request: dataRequestChangePassword})
            if (res != false) {
                if (res.Status == 'OK') {
                    createToastInterface().success('เปลี่ยนรหัสผ่านเรียบร้อย')
                } else {
                    createToastInterface().error(res.Msg)
                }
            } else {
                createToastInterface().error('เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน')
            }
            return res
        },
        async GetProfile({ dispatch, commit, state }) {
           
            let url = state.urlApi + '/yorkky/GetProfile'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {
                    commit('SET_PROFILE_DATA', res.Data)
                }
            }
            return res
        },
        async GetBalance({ dispatch, commit, state }, data = false) {
            // console.log('store.js => GetBalance', state.dataLogin)
            if (state.dataLogin != null) {
                let url = state.urlApi + '/yorkky/Balance'
                let dataRequestDeposit = {
                    Username: state.dataLogin.Username
                    ,UserToken: state.dataLogin.UserToken
                }
                let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
                if (res != false) {
                    if (res.Status == 'OK') {
                        if (data) createToastInterface().success('อัพเดทยอด Credit เรียบร้อย')
                        commit('SET_BALANCE', res.Data.Balance)
                    }
                }
                return res
            }
        },
        async GetStatement({ dispatch, commit, state }) {
           
            let url = state.urlApi + '/yorkky/GetStatement'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {
                }
            }
            return res
        },
        async TransactionBet({ dispatch, commit, state }) {
           
            let url = state.urlApi + '/member/TransactionBet'
            // date start - 7 days using moment
            let dateStart = moment().subtract(7, 'days').format('YYYY-MM-DD')
            let dateEnd = moment().format('YYYY-MM-DD')
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,dtStart: dateStart
                ,dtEnd: dateEnd
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {
                }
            }
            return res
        },
        async SendSlipDeposit({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/yorkky/SendSlipDeposit'
            let dataRequestSendSlipDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,REFID: state.depositDetail.REFID
                ,SLIPIMG: state.depositSlipDetail.IMGSource
            }
            let res = await dispatch('postData', {url: url, request: dataRequestSendSlipDeposit})
            if (res != false) {
                if (res.Status == 'OK') {
                    clearInterval(state.depositInterval)
                    state.depositInterval = null
                    state.depositDetail = null
                    state.depositTimeCount = state.depositTimeDefault
                    state.depositSlipDetail = null
                    createToastInterface().success('ส่งสลิปเรียบร้อย')
                } else {
                    createToastInterface().error(res.Msg)
                }
            } else {
                createToastInterface().error('เกิดข้อผิดพลาดในการส่งสลิป')
            }
            return res
        },
        async UploadSlip({ dispatch, commit, state }, data) {
            let url = 'https://uploads.facup.bet/'
            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            let result = await new Promise((resolve, reject) => {
                axios.post( url, data, config)
                .then((response) => {
                    if (response.status == 200) {
                        let data = response.data
                        resolve(data)
                    } else {
                        resolve(false)
                    }
                })
                .catch((error) => {
                    // console.log('store.js => postData', error)
                    resolve(false)
                })
            })
            if (result !== false && result.Status == 'OK') {
                createToastInterface().success('อัพโหลดสลิปสำเร็จ')
                // console.log('store.js => UploadSlip', JSON.stringify(result, null, 2))
                commit('SET_DEPOSIT_SLIP_DETAIL', result.Data)
            } else {
                createToastInterface().error('เกิดข้อผิดพลาดในการอัพโหลดสลิป')
            }
            return result
        },
        async DepositCancel({ dispatch, commit, state }) {
           
            let url = state.urlApi + '/yorkky/DepositCancel'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,REFID: state.depositDetail.REFID
                ,PROID: state.depositDetail.Promotion
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {
                    createToastInterface().success('ยกเลิกการเติมเงินเรียบร้อย')
                    clearInterval(state.depositInterval)
                    state.depositInterval = null
                    state.depositDetail = null
                    state.depositTimeCount = state.depositTimeDefault
                }
            }
        },
        async DepositReqCheck({ dispatch, commit, state }) {
            let url = state.urlApi + '/yorkky/DepositReqCheck'
            let dataRequestDeposit = { 
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,REFID: state.depositDetail.REFID
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {
                    clearInterval(state.depositInterval)
                    state.depositInterval = null
                    state.depositDetail = null
                    state.depositTimeCount = state.depositTimeDefault
                    state.depositSlipDetail = null
                    dispatch('GetBalance')
                    createToastInterface().success('เติมเงินสำเร็จ')
                } else {
                    if (res.isSpare == 1) {
                        clearInterval(state.depositInterval)
                        state.depositInterval = null
                        state.depositTimeCount = 0
                        createToastInterface().error('เกิดข้อผิดพลาดในการเติมเงิน: เนื่องจากธนาคารปิดปรับปรุง')
                    }
                }
            }
            return res
        },
        async DeposiCountStart({ dispatch,commit, state }, data) {
            if (state.depositInterval == null) {
                // time count  down mm:ss
                state.depositInterval = setInterval(() => {
                    dispatch('DepositReqCheck')
                    if (state.depositTimeCount > 0) {
                        state.depositTimeCount--
                    } else {
                        clearInterval(state.depositInterval)
                        state.depositInterval = null
                    }
                }, 1000)
            }
        },
        async Deposit({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/yorkky/DepositReq'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,Amount: data.Amount
                ,BankId: data.BankId
                ,AgentId: state.agentID
                ,Promotion: data.Promotion
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {
                    res.Data.dep_detail = {
                        Amount: data.Amount
                        ,BankId: data.BankId
                        ,AgentId: state.agentID
                        ,Promotion: data.Promotion
                    }
                    commit('SET_DEPOSIT_DETAIL', res.Data)
                    dispatch('DeposiCountStart')
                    // console.log('store.js => Deposit', JSON.stringify(res, null, 2))
                }
            }
            return res
        },
        async Withdraw({ dispatch, commit, state }, data) {
            let url = 'https://bo.facup.bet/Func/Withdraw/Req'
            let dataRequestDeposit = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
                ,Amount: data.Amount
                ,BankWithdraw: data.BankId
            }
            let res = await dispatch('postData', {url: url, request: dataRequestDeposit})
            if (res != false) {
                if (res.Status == 'OK') {
                    createToastInterface().success('ขอถอนเงินสำเร็จ')
                    // console.log('store.js => Deposit', JSON.stringify(res, null, 2))
                } else {
                    createToastInterface().error(res.Msg)
                }
            }
            return res
        },
        async PromotionList({ dispatch, commit, state }) {
            let url = state.urlApi + '/member/PromotionList'
            let dataRequestPromotionList = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestPromotionList})
            if (res != false) {
                if (res.Status == 'OK') {
                    // add plesase select promotion
                    if (res.hasOwnProperty('Data') && res.Data.length > 0) {
                        commit('SET_PROMOTION_LIST', res.Data)
                    }
                    // console.log('store.js => PromotionList', JSON.stringify(res.Data, null, 2))
                }
            }
            return res
        },
        async GetBankMember({ dispatch, commit, state }) {
            let url = state.urlApi + '/yorkky/GetBankMember'
            let dataRequestGetBankMember = {
                Username: state.dataLogin.Username
                ,UserToken: state.dataLogin.UserToken
            }
            let res = await dispatch('postData', {url: url, request: dataRequestGetBankMember})
            if (res != false) {
                commit('SET_BANK_DATA', res.Data)
                // console.log('store.js => GetBankMember', JSON.stringify(res.Data, null, 2))
            }
            return res
        },
        async JoinGame({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/yorkky/Client' + data
            let dataRequestGame = {
                AGEN_KEY: state.agentKey,
                Username: state.dataLogin.Username,
                UserToken: state.dataLogin.UserToken,
                urlApi: 'http://api-front-fa.demobetfamily.com'+'/yorkky',
            }
            dispatch('setIsLoadingProgress', true)
            let res = await dispatch('postData', {url: url, request: dataRequestGame})
            let resJoinGame = {'Status': 'ERROR', 'Msg': 'เกิดข้อผิดพลาดในการเข้าเกม'}
            if (res != false) {
                if (res.Status == 'OK') {
                    if (res.Data.url.startsWith('?')) {
                       let url = state.urlApi + '/yorkky/Player' + res.Data.url
                        resJoinGame = await dispatch('postData', {url: url, request: dataRequestGame})
                        if (resJoinGame != null && resJoinGame.Status == 'SUCCESS') {
                            
                        } else {
                            createToastInterface().error('เกิดข้อผิดพลาดในการเข้าเกม')
                        }
                        // console.log('store.js => JoinGame', resJoinGame)
                    } else {
                        resJoinGame = {
                            Status: "SUCCESS",
                            Data: {
                                gameurl: res.Data.url
                            },
                            Msg: "เข้าเกมสำเร็จ"
                        }
                    }
                    // console.log('store.js => JoinGame', res.Data.url)
                    // let url = state.urlApi + '/yorkky/Player' + res.Data.url
                    // resJoinGame = await dispatch('postData', {url: url, request: dataRequestGame})
                    // if (resJoinGame != null && resJoinGame.Status == 'SUCCESS') {
                        
                    // } else {
                    //     createToastInterface().error('เกิดข้อผิดพลาดในการเข้าเกม')
                    // }
                    // console.log('store.js => JoinGame', resJoinGame)
                } else {
                    createToastInterface().error(res.Msg)
                }
            }
            dispatch('setIsLoadingProgress', false)
            return resJoinGame
        },
        async GetGamePage({ dispatch, commit, state }, data) {
            let url = state.urlApi + '/yorkky/GamePageNew'
            let dataRequestGame = {
                AgentId: state.agentID,
                Username: state.dataLogin != null ? state.dataLogin.Username : '',
                UserToken: state.dataLogin != null ? state.dataLogin.UserToken : '',
                CategoryId: typeof data == 'object' && data.hasOwnProperty('GAME_CATEGORY_ID') ? data.GAME_CATEGORY_ID : '',
                GameProvider: "",
                Mode: "ListGame",

            };
            if(data != null && typeof data == 'object' && data.hasOwnProperty('is_loading') && data.is_loading == true) {
                await dispatch('setIsLoadingProgress', true)
            }
            let res = await dispatch('postData', {url: url, request: dataRequestGame})
            if (res != false) {
                if (res.Status == 'OK') {
                    if (typeof data == 'object' && data.hasOwnProperty('GAME_HITS') && data.GAME_HITS == true) {
                        if (data.hasOwnProperty('GAME_HOME') && data.GAME_HOME == true) {
                            res.Data.GameData.GAME_CATEGORY_ID = data.GAME_CATEGORY_ID
                            // console.log('store.js => GetGamePage ccc', res.Data.GameData)
                            commit('SET_GAME_DATA_CATE_HOME_PAGE', res.Data.GameData)
                        } else {
                            commit('SET_GAME_DATA_DETAIL_HOME_PAGE', res.Data.GameData.Data)
                            
                        }
                       
                    } else {
                        commit('SET_GAME_CATEGORY_LIST', res.Data.GameCategory)
                        let gameNewList = []
                        if (res.Data.GameCategory.length > 0) {
                            // slice 4 item
                            gameNewList = res.Data.GameCategory.slice(0, 2)
                            for (let index in gameNewList) {
                                if (index == 0) gameNewList[index]['active'] = true 
                                else gameNewList[index]['active'] = false
                                gameNewList[index]['image'] = state.gameHitListImage[index].image
                            }
                            commit('SET_GAME_HIT_LIST', gameNewList)
                            
                        }
                        if (typeof data == 'object' && data.hasOwnProperty('GAME_CATEGORY_ID')) {
                            // move pgslot to first
                            // console.log('store.js => GetGamePage', res.Data.GameData.Data)
                            let dupp = JSON.parse(JSON.stringify(res.Data.GameData.Data))
                            let checkKeyPGSlot = Object.keys(dupp).indexOf('PGSlot')
                            if (checkKeyPGSlot != -1) {
                                let pgSlot = dupp.PGSlot
                                delete dupp.PGSlot
                                dupp = {PGSlot: pgSlot, ...dupp}
                            }
                            // console.log('store.js => GetGamePage', dupp)
                            commit('SET_GAME_DATA_DETAIL', dupp)
                        }
                    }
                }
            }
            if(data != null && typeof data == 'object' && data.hasOwnProperty('is_loading') && data.is_loading == true) {
                dispatch('setIsLoadingProgress', false)
            }
            // console.log('store.js => GetGamePage', res)
            return res
        },
        async RegisterData({dispatch, commit, state}, data) {
            if (data.MEMBER_ACCID == '') {
                createToastInterface().error('กรุณากรอกเลขบัญชีธนาคาร')
                return false
            }
            if (data.isAllowBankName && data.bankName == '') {
                createToastInterface().error('กรุณากรอกชื่อธนาคาร')
                return false
            }
            let objPrepareRegister = {
                MEMBER_LINE: '',
                MEMBER_IP: '',
                MEMBER_BANK: data.MEMBER_BANK,
                MEMBER_ACCID: data.MEMBER_ACCID,
                MEMBER_BANK_NAME: data.MEMBER_BANK_NAME,
                MEMBER_TRUE_ACCID: '',
                MEMBER_CONTACT: '',
                UPLINE_TOKEN: state.agentKey,
                MEMBER_TEL: state.registerData.tel,
                MEMBER_PASSWORD: state.registerData.password,
                MEMBER_OTP: state.registerData.otp,
                MEMBER_AF_TOKEN: state.afToken,
                MEMBER_REFERER_TOKEN: '',
                MEMBER_LINE_IDENTIFIER: '',
            }
            let resultPrepair = await dispatch('prepairData', objPrepareRegister)
            if (resultPrepair !== false && resultPrepair.status == "OK" ) {
                let objRegister = {
                    OTP: state.registerData.otp,
                    JSONRAW : resultPrepair.data
                }
                let urlRegister = state.urlApi + '/yorkky/Register'
                let resultRegister = await dispatch('postData', {url: urlRegister, request: objRegister})
                if (resultRegister !== false) {
                    if (resultRegister.Status == 'OK') {
                        createToastInterface().success('สมัครสมาชิกสำเร็จ')
                        commit('SET_DATA_REGISTER', {key: 'step', value: 'step_register_success'})
                        commit('SET_STEP_REGISTER', 'step_register_success')
                        let objSignIn = {
                            Username: state.registerData.tel,
                            Password: state.registerData.password
                        }
                        let resLogin = await dispatch('signIn', objSignIn)
                        if (resLogin != false) {
                            location.reload()
                        }
                    } else {
                        if (resultRegister.Code == 1001) {
                            commit('SET_DATA_REGISTER', {key: 'step', value: 'step_bank_account'})
                            commit('SET_DATA_REGISTER', {key: 'member_bank', value: data.MEMBER_BANK})
                            commit('SET_DATA_REGISTER', {key: 'member_accid', value: data.MEMBER_ACCID})
                            commit('SET_STEP_REGISTER', 'step_bank_account')
                            
                            createToastInterface().error(resultRegister.Msg)
                           
                        } else {
                            createToastInterface().error(resultRegister.Msg)
                            
                        }
                    }
                    return resultRegister
                }
                // console.log('store.js => RegisterData', resultRegister)
            }
            
        },
        async prepairData({ dispatch ,commit, state }, data) {
            let requestPayload = {
                data_raw: JSON.stringify(data)
            }
            let dataReq =  {}
            dataReq['url'] = state.urlApi + '/member/encodeData'
            dataReq['request'] = requestPayload
            let resultPrepair = await dispatch('postData', dataReq)
            // console.log('store.js => prepairData', resultPrepair)
            return resultPrepair
        },
        async CheckPassword({ dispatch ,commit, state }, data) {
            if (data.pass == '') {
                createToastInterface().error('กรุณากรอกรหัสผ่าน');
                return false
            }
            if (data.pass_confirm == '') {
                createToastInterface().error('กรุณากรอกยืนยันรหัสผ่าน');
                return false
            }
            if (data.pass != data.pass_confirm) {
                createToastInterface().error('รหัสผ่านไม่ตรงกัน');
                return false
            }
            commit('SET_DATA_REGISTER', {key: 'password', value: data.pass})
            commit('SET_DATA_REGISTER', {key: 'confirmPassword', value: data.pass_confirm})
            commit('SET_DATA_REGISTER', {key: 'step', value: 'step_bank_account'})
            commit('SET_STEP_REGISTER', 'step_bank_account')

            await dispatch('GetBankCode')

        },
        async GetBankCode({ commit, state }) {
            let url = state.urlApi + '/yorkky/getBankCode'
            let res = await new Promise((resolve, reject) => {
                axios.get( url)
                .then((response) => {
                    if (response.status == 200) {
                        let data = response.data
                        resolve(data)
                        // console.log('store.js => GetBankCode', data)
                    } else {
                        resolve(false)
                    }
                })
                .catch((error) => {
                    // console.log('store.js => GetBankCode', error)
                    resolve(false)
                })
                
            })
            
            if (res !== false) {
                let newConvertArr = []
                if (typeof res.data == 'object' && Object.keys(res.data).length > 0) {
                    for (let item in res.data) {
                        newConvertArr.push(res.data[item])
                    }
                }
                // console.log('store.js => GetBankCode -> newConvertArr', newConvertArr)
                commit('SET_BANK_LIST', newConvertArr)
            }
            return res
        },
        async ConfirmOTP({ commit, state }, data) {
            let url = state.urlApi + '/yorkky/ConfirmOTP'
            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            let formData = new FormData()
            formData.append('TEL', data.tel)
            formData.append('OTP', data.otp)
            let res = await new Promise((resolve, reject) => {
                axios.post( url, formData, config)
                .then((response) => {
                    if (response.status == 200) {
                        let data = response.data
                        resolve(data)
                        // console.log('store.js => ConfirmOTP', data)
                    } else {
                        resolve(false)
                    }
                })
                .catch((error) => {
                    // console.log('store.js => ConfirmOTP', error)
                    resolve(false)
                })
                
            })
            // console.log('store.js => ConfirmOTP', res)
            if (res !== false && res.Status == 'OK') {
                commit('SET_DATA_REGISTER', {key: 'otp', value: data.otp})
                commit('SET_DATA_REGISTER', {key: 'step', value: 'step_password'})
                commit('SET_STEP_REGISTER', 'step_password')
            }
            return res
        },
        async requestOTP({ commit, state }, data) {
            let url = state.urlApi + '/yorkky/RequestOTP'
            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            let formData = new FormData()
            formData.append('UPLINE_TOKEN', state.agentKey)
            formData.append('MEMBER_AF_TOKEN', state.afToken)
            formData.append('TEL', data.tel)
            let res = await new Promise((resolve, reject) => {
                axios.post( url, formData, config)
                .then((response) => {
                    if (response.status == 200) {
                        let data = response.data
                        resolve(data)
                        // console.log('store.js => requestOTP', data)
                    } else {
                        resolve(false)
                    }
                })
                .catch((error) => {
                    // console.log('store.js => requestOTP', error)
                    resolve(false)
                })
                
            })
            // console.log('store.js => requestOTP', res)
            if (res !== false && res.Status == 'OK') {
                if (res.status_otp == 1) {
                    commit('SET_STEP_REGISTER', 'step_confirm_otp')
                    commit('SET_DATA_REGISTER', { key: 'step', value: 'step_confirm_otp' })
                } else {
                    commit('SET_STEP_REGISTER', 'step_password')
                    commit('SET_DATA_REGISTER', { key: 'step', value: 'step_password' })
                }
                commit('SET_DATA_REGISTER', { key: 'tel', value: data.tel })
            } else {
                createToastInterface().error(res.Msg)
            }
            
            return res
        },
        async lineLogin({ commit, state }) {
            // get url full 
            let urlData = getParameterByName('Data')
            let otp = getParameterByName('token')
            // let endcrypt = encrypt("test", otp)
            // let parsing = decrypt(endcrypt, otp)
            // console.log('store.js => lineLogin endcrypt', endcrypt) 
            // console.log('store.js => lineLogin', parsing)    
            let url = state.urlApi + '/member/DecyptData'
            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            let obj = {
                Data: urlData,
                Token: otp
            }
            let res = await new Promise((resolve, reject) => {
                axios.post( url, obj, config)
                .then((response) => {
                    if (response.status == 200) {
                        let data = response.data
                        let dataSplit = data.data.split('&')
                        let objParam = {}
                        if (typeof dataSplit == 'object' && dataSplit.length > 0) {
                            dataSplit.map((item) => {
                                let itemSplit = item.split('=')
                                objParam[itemSplit[0]] = itemSplit[1]
                            })
                        }
                        Cookies.set('yrkLogin', true);
                        Cookies.set('yrkUserUpline', objParam.Upline);
                        Cookies.set('yrkUserToken', objParam.UserToken);
                        Cookies.set('yrkName', objParam.Name);
                        Cookies.set('yrkUsername', objParam.User);
                        Cookies.set('yrkBalance', objParam.Balance);
                        Cookies.set('yrkLiveChat', objParam.LiveChatFlag);
                        commit('SET_MODAL_LOGIN', false)

                        // console.log('store.js => lineLogin', objParam)
                        location.assign(location.origin)
                    }
                    resolve(true)
                })
                .catch((error) => {
                    // console.log('store.js => signIn', error)
                    resolve(true)
                })
                
            })
            if (res) {
                commit('AUTHEN_SYNC')
            }
        },
        async postData({ commit, state, dispatch }, data) {
            let url = data.url
            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            let formData = new FormData()
            for (let key in data.request) {
                
                if (typeof data.request[key] == 'object') {
                    Object.keys(data.request[key]).map((item) => {
                        formData.append(key + '['+ item +']', data.request[key][item])
                    })
                } else {
                    formData.append(key, data.request[key])
                }
            }

            let result = await new Promise((resolve, reject) => {
                axios.post( url, formData, config)
                .then((response) => {
                    if (response.status == 200) {
                        let data = response.data
                        resolve(data)
                    } else {
                        // console.log('store.js => postData', response)
                        resolve(false)
                    }
                })
                .catch((error) => {
                    if (error.status == 401) {
                        createToastInterface().error('กรุณาเข้าสู่ระบบ')
                        dispatch('logout')
                        
                    }
                    // console.log('store.js => postData', error)
                    resolve(false)
                })
            })
            return result
        },
        setModalLogin({ commit }, data) {
            commit('SET_MODAL_LOGIN', data)
        },
        setModalRegister({ commit }, data) {
            commit('SET_MODAL_REGISTER', data)
        },
        addCart({ commit }, data) {
            commit('ADD_CART', data)
        },
        removeCart({ commit }, data) {
            commit('REMOVE_CART', data)
        },
        signInWithLine({ commit, state }) {
            // convery php to js $OTP  = rand(100000,999999);
            let OTP = Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000;
            let urlLine = state.urlBo + '/Func/LineAuthenticator/Login?OTP='+OTP+'&AGENTKEY='+state.agentKey+'&RefererToken='+''+"&AFToken="+''+"&returnURL="+location.origin
            // console.log(urlLine)
           window.location.href = urlLine
        },
        async signIn({ commit, state }, data) {
            let url = state.urlApi + '/yorkky/Login'
            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            let formData = new FormData()
            formData.append('Username', data.Username)
            formData.append('Password', data.Password)
            formData.append('Upline', state.agentKey)
            let res = await new Promise((resolve, reject) => {
                axios.post( url, formData, config)
                .then((response) => {
                    // console.log('store.js => signIn', response)
                    if (response.status == 200) { 
                        if (response.data.Status == 'ERROR') {
                            createToastInterface().error(response.data.Msg)
                        } else {
                            let data = response.data
                            Cookies.set('yrkLogin', true);
                            Cookies.set('yrkUserUpline', data.Data.Upline);
                            Cookies.set('yrkUserToken', data.Data.UserToken);
                            Cookies.set('yrkName', data.Data.Name);
                            Cookies.set('yrkUsername', data.Data.Username);
                            Cookies.set('yrkBalance', data.Data.Balance);
                            Cookies.set('yrkLiveChat', data.Data.LiveChatFlag);
                            commit('SET_MODAL_LOGIN', false)
                            createToastInterface().success('เข้าสู่ระบบสำเร็จ')
                            setTimeout(() => {
                                location.reload() 
                            }, 1000)
                        }
                    }
                    resolve(true)
                })
                .catch((error) => {
                    // console.log('store.js => signIn', error)
                    resolve(true)
                })
                
            })
            if (res) {
                commit('AUTHEN_SYNC')
            }
            return res
        },
        authenSycn({ commit }) {
            commit('AUTHEN_SYNC')
        },
        logout({ commit }) {
            Cookies.remove('yrkLogin');
            Cookies.remove('yrkUserUpline');
            Cookies.remove('yrkUserToken');
            Cookies.remove('yrkName');
            Cookies.remove('yrkUsername');
            Cookies.remove('yrkBalance');
            Cookies.remove('yrkLiveChat');
            commit('AUTHEN_SYNC')
        },
        setGameCateCurrent({ commit }, data) {
            commit('SET_GAME_CATE_CURRENT', data)
        },
        setGameCateListCurrent({ commit }, data) {
            commit('SET_GAME_CATE_LIST_CURRENT', data)
        },
        async setIsLoadingProgress({ commit }, data) {
            commit('SET_IS_LOADING_PROGRESS', data)
        },
        setGameHitCurrent({ commit }, data) {
            commit('SET_GAME_HIT_CURRENT', data)
        },
        setGameHitList({ commit, state }, data) {
            let dataGameHitList = JSON.parse(JSON.stringify(state.gameHitList))
            for (let index in dataGameHitList) {
                dataGameHitList[index]['active'] = false
                if (dataGameHitList[index]['GAME_CATEGORY_ID'] == data['GAME_CATEGORY_ID']) {
                    dataGameHitList[index]['active'] = true
                }
            }
            commit('SET_GAME_HIT_LIST', dataGameHitList)
        },
        setAfToken({ commit }, data) {
            commit('SET_AF_TOKEN', data)
        }

    },
    mutations: {
        SET_DATA_ANNOUNCE(state, data) {
            state.dataAnnounce = data
        },
        SET_MEMBER_DETAIL(state, data) {
            state.memberDetail = data
        },
        SET_AF_TOKEN(state, data) {
            state.afToken = data
        },
        SET_PROFILE_DATA(state, data) { 
            state.profileData = data
        },
        SET_BALANCE(state, data) {
            state.balance = data
        },
        SET_DEPOSIT_SLIP_DETAIL(state, data) {
            state.depositSlipDetail = data
        },
        SET_DEPOSIT_DETAIL(state, data) {
            state.depositDetail = data
        },
        SET_PROMOTION_SELECTED(state, data) {
            state.promotionSelected = data
        },
        SET_PROMOTION_LIST(state, data) {
            state.PromotionList = data
        },
        SET_BANK_DATA(state, data) {
            state.bankData = data
        },
        SET_GAME_HIT_LIST(state, data) {
            state.gameHitList = data
        },
        SET_GAME_HIT_CURRENT(state, data) {
            state.gameHitCurrent = data
        },
        SET_GAME_CATE_LIST_CURRENT(state, data) {
            state.gameCateListCurrent = data
        },
        SET_GAME_DATA_CATE_HOME_PAGE(state, data) {
            let getDataState = state.gameDataCateHomePage
            , pos = getDataState.findIndex(item => item.GAME_CATEGORY_ID == data.GAME_CATEGORY_ID)
            if (pos == -1) {
                state.gameDataCateHomePage.push(data)
            } else {
                state.gameDataCateHomePage[pos] = data
            }
            // console.log('store.js => SET_GAME_DATA_CATE_HOME_PAGE', state.gameDataCateHomePage)
        },
        SET_GAME_DATA_DETAIL_HOME_PAGE(state, data) {
            state.gameDataDetailHomePage = data
        },
        SET_IS_LOADING_PROGRESS(state, data) {
            state.isLoadindProgress = data
        },
        SET_GAME_CATE_CURRENT(state, data) {
            state.gameCateCurrent = data
        },
        SET_GAME_DATA_DETAIL(state, data) {
            state.gameDataDetail = data
        },
        SET_GAME_CATEGORY_LIST(state, data) {
            state.gameCategoryList = data
        },
        SET_BANK_LIST(state, data) {
            state.bankList = data
        },
        SET_DATA_REGISTER(state, data) {
            state.registerData[data['key']] = data['value']
        },
        SET_STEP_REGISTER(state, data) {
            state.registerStep = data
        },
        SET_MODAL_LOGIN(state, data) {
            state.modalLogin = data
            // console.log('store.js => SET_MODAL_LOGIN', state.modalLogin)
        },
        SET_MODAL_REGISTER(state, data) {
            state.modalRegister = data
            // console.log('store.js => SET_MODAL_REGISTER', state.modalRegister)
        },
        ADD_CART(state, data) {

            let productExist = false;

            state.newProducts = state.newProducts.map(product => {
                if (product.id == data.id) {
                    productExist = true
                    product.qty += 1
                }
                return product
            })

            if (!productExist) {
                data.qty += 1
                state.newProducts.push(data);

            }
        },
        REMOVE_CART(state, data) {
            data.qty -= 1
            if (data.qty == 0) {
                let product = state.newProducts.filter(product => product.id != data.id)
                state.newProducts = product
            }

        },
        async SIGN_IN(state, data) {
           
        },
        async AUTHEN_SYNC(state, data) {
            // console.log('store.js => AUTHEN_SYNC',  Cookies.get('yrkLogin'))
            if (Cookies.get('yrkLogin')) {
                state.dataLogin = {
                    Upline: Cookies.get('yrkUserUpline'),
                    UserToken: Cookies.get('yrkUserToken'),
                    Name: Cookies.get('yrkName'),
                    Username: Cookies.get('yrkUsername'),
                    Balance: Cookies.get('yrkBalance'),
                    LiveChatFlag: Cookies.get('yrkLiveChat')
                }
                // banner
                state.bannerHome = state.bannerHomeDefault.filter(item => item.is_login == true)
                // console.log('store.js => AUTHEN_SYNC', state.bannerHomeDefault)
                state.isLogin = true
            } else {
                state.dataLogin = null
                state.isLogin = false
                state.bannerHome = state.bannerHomeDefault.filter(item => item.is_login == false)
            }
        }
        

    },

})


function getParameterByName(name) {
    if (name !== "" && name !== null && name != undefined) {
        // eslint-disable-next-line
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    } else {
        var arr = location.href.split("/");
        return arr[arr.length - 1];
    }
}

// public function decypt($string,$xkey){
//     $secret_key = $xkey;
//     $secret_iv = $xkey;
//     $output = false;
//     $encrypt_method = "AES-256-CBC";
//     $key = hash('sha256', $secret_key);
//     $iv = substr(hash('sha256', $secret_iv), 0, 16);
//     $output = openssl_decrypt($string, $encrypt_method, $key, 0, $iv);
//     return $output;
// }
// convert to js 
const CryptoJS = require('crypto-js');
function encrypt(string, xkey) {
    let secret_key = xkey+"A8";
    let secret_iv = xkey+"A8";
    let key = CryptoJS.SHA256(secret_key).toString();
    let iv = CryptoJS.SHA256(secret_iv).toString().substring(0, 16);
    let encrypted = CryptoJS.AES.encrypt(string, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.NoPadding
    });
    return encrypted.toString();
}
function decrypt(string, xkey) {
    // console.log('store.js => decrypt: string', string)
    // console.log('store.js => decrypt: xkey', xkey)
    let secret_key = xkey+"A8";
    let secret_iv = xkey+"A8";
    // console.log('store.js => decrypt: secret_key', secret_key)
    // console.log('store.js => decrypt: secret_iv', secret_iv)
    let key = CryptoJS.SHA256(secret_key).toString();
    let iv = CryptoJS.SHA256(secret_iv).toString().substring(0, 16);
    // console.log('store.js => decrypt: key', key)
    // console.log('store.js => decrypt: iv', iv)
    // let decData = CryptoJS.enc.Base64.parse(string)
    // console.log('store.js => decrypt: decData', decData)
    let decrypted = CryptoJS.AES.decrypt({ciphertext: string}, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding

    });
    // console.log('store.js => decrypt: decrypted', decrypted)
    // console.log('store.js => decrypt: decrypted.toString(CryptoJS.enc.Utf8)', decrypted.toString( CryptoJS.enc.Utf8)) 
    return decrypted.toString();

    // const secretKey = xkey+"A8";
    // const secretIv = xkey+"A8";
    // const encryptMethod = CryptoJS.AES;
    
    // const key = CryptoJS.SHA256(secretKey);
    // const iv = CryptoJS.enc.Hex.parse(CryptoJS.SHA256(secretIv).toString().substr(0, 32));

    // const decrypted = encryptMethod.decrypt(
    //     { ciphertext: CryptoJS.enc.Base64.parse(string) },
    //     key,
    //     { iv: iv }
    // );
    // console.log('store.js => decrypt: decrypted', decrypted.toString(CryptoJS.enc.Utf8))
    // return decrypted.toString(CryptoJS.enc.Utf8);

    
}
